
import { Component, Vue } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import { PostLogin } from "@/request/account";
import { clearFilter } from "@/utils/base";
@Component({})
export default class Login extends Vue {
  private window: any = window;
  private info: any = {
    用户名: "",
    密码: "",
  };
  private rules: any = {
    用户名: [{ required: true, message: "账户名必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }],
  };
  private get configuration() {
    return this.$store.state.configuration;
  }
  private login() {
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      const Base64 = require("js-base64").Base64;
      if (isValid) {
        const params: any = {
          account: this.info["用户名"],
          密码: this.info["密码"],
        };
        PostLogin(this, params)
          .then((res) => {
            this.$store.commit("updateToken", res.token);
            this.$store.commit("updateUser", res.user);
            clearFilter();
            if (this.configuration.leftNav[0].path) {
              this.$router.push(this.configuration.leftNav[0].path);
            } else {
              this.$router.push(this.configuration.leftNav[0].children[0].path);
            }
          })
          .catch((error: any) => {
            if (typeof error === "string") {
              this.$message.error(error);
            }
          });
      }
    });
  }
}
